import { AngelPlayer } from '@/organisms/AngelPlayer'
import { Torch } from '@/services/TorchesService'
import { ICampaignAssetsFields } from '@/types/generated-contentful'
import { useTorchAsset } from '@/utils/TorchGuildUtil'
import { useTranslate } from '@/utils/translate/translate-client'

interface TorchVideoHeroProps {
  campaignAssets: ICampaignAssetsFields
  campaignSlug: string
  torch: Torch
}

export const TorchVideoHero: React.FC<TorchVideoHeroProps> = ({ campaignAssets, campaignSlug, torch }) => {
  const { t } = useTranslate('torches')

  const name = t('torchCardName', 'Torch Video')
  const subtitle = t('torchInvestSubtitle', 'View torch for your consideration')
  const asset = useTorchAsset({
    torch,
    name,
    poster: campaignAssets.image.fields.file.url,
    slug: campaignSlug,
    subtitle,
    videoType: 'torch',
  })

  return (
    <div className="relative w-full lg:flex-1">
      <AngelPlayer playerContainerClassName="w-full" asset={asset} autoplay />
    </div>
  )
}
